// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs, EffectFade } from 'swiper/modules';

// import Swiper and modules styles
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';

document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('.js-func-gallery');

    sliders.forEach(slider => {
        const parentNav = slider.querySelector('.js-func-gallery-nav');
        const parentHero = slider.querySelector('.js-func-gallery-hero');

        const swiperNav = new Swiper(parentNav, {
            // Install modules
            modules: [Navigation, Pagination, Thumbs],
            spaceBetween: 0,
            // slidesPerView:1,

            centeredSlides: false,
            centeredSlidesBounds: true,
            slidesPerView: 'auto',
            watchOverflow: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            direction: 'vertical'
        });

        const swiperHero = new Swiper(parentHero, {
            // Install modules
            modules: [Navigation, Pagination, Thumbs, EffectFade],
            thumbs: {
                swiper: swiperNav,
                slideThumbActiveClass: 'is-active',
            },
            spaceBetween: 0,
            slidesPerView: 1,
            centeredSlides: false,

            watchOverflow: true,
            speed: 1000,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
                // // false - Включает плавное затухание слайдов
                // // Обратите внимание, что crossFadeследует установить значение true,
                // // чтобы не видеть содержимое позади или под ним.
            },

            // on: {
            //     slideChange: function () {
            //         let index = this.realIndex;
            //         console.log(`index = ${index}`);
            //         swiperNav.slideTo(index ? index - 1 : index)
            //     },
            // }
        });


        // init Swiper:

        // const swiper = new Swiper('.swiper', {
        //   // configure Swiper to use modules
        //   modules: [Navigation, Pagination],
        //   ...
        // });

    });

});


